<template>
	<div>
		<!-- breadcrumb area -->
		<div class="breadcrumb-area breadcrumb-padding bg-img" :style="{backgroundImage:`url(${bgImg})`}">
			<div class="container">
				<div class="breadcrumb-content text-center">
					<h2>关于我们</h2>
				</div>
			</div>
		</div>
		<!-- Project area -->
		<div class="section section-padding">
			<div class="container">
				<div class="project-details-wrap">
					<div class="project-details-img mb-5 mb-md-9">
						<img src="@/assets/images/project/project-details-1.jpg" alt="Project Image">
					</div>
					<div class="row">
						<div class="col-lg-9 col-md-8">
							<div class="project-details-content mb-4 mb-md-9">
								<h1 class="title">筑壳（深圳）科技有限公司</h1>
								<p>筑壳是全球首个场景化建筑设计装饰内容发现中心。
									筑壳成立的使命是助推整个行业发展，用场景化呈现让空间更美好，真诚助力于让国内的空间领域相关产业链走向世界和造福世界，传播中国设计和中国产品，赋能产业链上的企业和机构。
								</p>
							</div>
						</div>
						<div class="col-lg-3 col-md-4">
							<div class="project-details-info">
								<ul>
									<li><span>电话: </span>0755-83065200</li>
									<li><span> </span>13652413182</li>
									<li><span>地址: </span>深圳市福田区市花路8号T8旅游创意园422</li>
								</ul>
							</div>
							<div class="social-icon-style mb-5">
								<a class="facebook" href="https://weibo.com/u/7764675727" target="_black"><img
										src="@/assets/images/testimonial/群组 2@2x.png" alt=""></a>
								<Poptip trigger="hover" content="content">
									<img src="@/assets/images/testimonial/群组@2x.png" alt=""
										style="width: 31px;height: 31px;margin-right: 10px;">
									<div slot="content">
										<img src="@/assets/images/微信视频号.png" alt="">
									</div>
								</Poptip>
								<Poptip trigger="hover" content="content">
									<img src="@/assets/images/testimonial/群组 3@2x.png" alt=""
										style="width: 31px;height: 31px;margin-right: 10px;">
									<div slot="content">
										<img src="@/assets/images/抖音.png" alt="">
									</div>
								</Poptip>
								<a class="behance"
									href="https://www.xiaohongshu.com/user/profile/6297006800000000210252f4"
									target="_black"><img src="@/assets/images/testimonial/群组 4@2x.png" alt=""></a>
								<a class="zhihu" href="https://www.zhihu.com/people/42-58-37-64" target="_black"><img
										src="@/assets/images/other (1).png" alt=""></a>
								<Poptip trigger="hover" content="content">
									<img src="@/assets/images/other (2).png" alt=""
										style="width: 31px;height: 31px;margin-right: 10px;">
									<div slot="content">
										<img src="@/assets/images/快手.png" alt="">
									</div>
								</Poptip>
							</div>
							<div class="social-icon-style mb-5">
								<a class="blbl" href="https://space.bilibili.com/1798548694" target="_black"><img
										src="@/assets/images/other (3).png" alt=""></a>
								<a class="douban" href="https://www.douban.com/people/257741962/?_i=4652198DcYu4CG"
									target="_black"><img src="@/assets/images/other (4).png" alt=""></a>
							</div>
						</div>
					</div>
					<div class="row row-cols-lg-3 row-cols-md-3 row-cols-sm-3 row-cols-1 mb-n6">
						<div class="col mb-6">
							<div class="project-details-img">
								<img src="@/assets/images/project/project-details-2.jpg" alt="Project Image">
							</div>
						</div>
						<div class="col mb-6">
							<div class="project-details-img">
								<img src="@/assets/images/project/project-details-3.jpg" alt="Project Image">
							</div>
						</div>
						<div class="col mb-6">
							<div class="project-details-img">
								<img src="@/assets/images/project/project-details-4.jpg" alt="Project Image">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				bgImg: require('../static/images/banner/banner-3.jpg'),
			}
		},
		created() {},
		computed: {},
		methods: {

		}
	}
</script>

<style>
</style>
